import StaffMemberJob from './StaffMemberJob.container';

export default StaffMemberJob;
